import { getCoreThemeColors } from "lib/utils/helpers";
import Biology from "../../../public/static/icons/subjects/biologyicon.svg";
import Chemistry from "../../../public/static/icons/subjects/chemistryicon.svg";
import Maths from "../../../public/static/icons/subjects/mathsicon.svg";
import Physics from "../../../public/static/icons/subjects/physicsicon.svg";

const subjectIcons: { [key: string]: any } = {
  biology: Biology,
  chemistry: Chemistry,
  physics: Physics,
  maths: Maths,
};

export default function RawSubjectIcon({
  subjectColorIndex,
  className,
  size = 100,
  withStroke,
}: {
  subjectColorIndex: string;
  withStroke?: boolean;
  className?: string;
  size?: number | string;
}) {
  const colors = getCoreThemeColors();
  const Icon = subjectIcons[subjectColorIndex];
  const color = colors[subjectColorIndex][7];
  const strokeColor = colors[subjectColorIndex][7];
  return (
    <Icon
      className={className}
      fill={color}
      stroke={withStroke ? strokeColor : undefined}
      width={size}
      height={size}
    />
  );
}
